import { default as SubscriptionsSectionContainer } from './SubscriptionsSection.container';
import { default as SubscriptionsSection } from './SubscriptionsSection';

export default SubscriptionsSectionContainer(SubscriptionsSection);
